export const styles = {
  container: {
    backgroundColor: '#F9F9FF',
    padding: '0 20px 20px 20px',
    borderRadius: 10,
    marginTop: 10,
  },
  title: {
    fontSize: 20,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#011533',
    fontWeight: '700',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 20,
  },
  columnHeader: {
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#707087',
    fontWeight: '500',
  },
  columnValue: {
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#011533',
  },
  userLink: {
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#011533',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  link: {
    fontFamily: "'Proxima Nova Alt', sans-serif",
    fontSize: 16,
    fontWeight: '700',
    color: '#011533',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  row: {
    marginTop: 20,
    paddingLeft: 20,
  },
  button: { width: 180 },
  cancelButton: { minWidth: 80, maxWidth: 80, height: 30, fontSize: 14 },
}
